var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    {
      staticClass: "w-100",
      attrs: {
        value: _vm.value,
        placeholder: _vm.placeholder,
        clearable: _vm.clearable,
        filterable: "",
        remote: "",
        "remote-method": _vm.search,
        loading: _vm.loading,
        "value-key": "id",
      },
      on: { change: _vm.onChange },
    },
    _vm._l(_vm.options, function (group) {
      return _c(
        "el-option-group",
        { key: group.label, attrs: { label: group.label } },
        _vm._l(group.items, function (item) {
          return _c(
            "el-option",
            { key: item.id, attrs: { label: item.label, value: item } },
            [
              _vm.isContact(item)
                ? _c("div", [
                    _c("i", { staticClass: "fas fa-user" }),
                    _c("span", { staticClass: "ml-2" }, [
                      _vm._v(_vm._s(item.label)),
                    ]),
                  ])
                : _c("div", [
                    _c("span", [
                      _c("i", { staticClass: "fas fa-user" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(_vm._s(item.labelData.contact)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-2" }, [
                      _c("i", { staticClass: "fas fa-phone-square" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(_vm._s(item.labelData.outgoingNumber)),
                      ]),
                    ]),
                  ]),
            ]
          )
        }),
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }